import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { AnimatedViews, Icon, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const SavedPaymentMethodLoading = (props: Props) => {
  const { index, hasDivider = false } = props;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const descriptionWidthStyle = useStyle(
    () => ({ width: DESCRIPTION_WIDTHS[index % DESCRIPTION_WIDTHS.length] }),
    [index],
  );
  const containerStyles = [styles.container, hasDivider ? styles.divider : undefined];
  const descriptionStyles = [styles.description, descriptionWidthStyle];

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <AnimatedViews.Pulse index={index} style={containerStyles}>
      <View style={styles.content}>
        <View style={styles.icon} />
        <View style={descriptionStyles} />
      </View>

      <Icon name="IconCaretRight" width={16} height={16} />
    </AnimatedViews.Pulse>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DESCRIPTION_WIDTHS = [168, 124, 148];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: theme.spacing['6'],
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.LIGHT,
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
  },
  icon: {
    width: 24,
    height: 24,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  description: {
    height: 10,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  index: number;
  hasDivider?: boolean;
};
